import React, { Component } from "react";
import { connect } from 'react-redux';
import classes from "./FlightTupleRoundTrip.scss";
import RoundTripHeader from "../RoundTripHeader/RoundTripHeader";
import FlightDetailsRoundTrip from "../FlightDetailsRoundTrip/FlightDetailsRoundTrip";
import TupleInner from "./RoundTupleInner/RoundTupleInner";
import Media from 'react-media';
import ButtonProceedMobile from '../../UI/Button/ButtonProceedMobile/ButtonProceedMobile';
import { withRouter } from 'react-router-dom';
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

import HeadingH4 from '../../UI/Headings/HeadingH4/HeadingH4';

import * as roundTripSummaryActions from '../../../store/actions/index';
import * as stackFlightActions from '../../../store/actions/index';
import * as uiActions from '../../../store/actions/index';

import flightDetailIcon from '../../../assets/images/flightdetail-icon.svg';
import { List, AutoSizer, WindowScroller } from "react-virtualized";

class flightTupleRoundTrip extends Component {

  departHandler = (flightId, index) => {
    this.props.onSetDepartId(flightId, index);
    this.props.onCloseRoundTripFareRules();
    this.departList.forceUpdateGrid();
  };

  returnHandler = (flightId, index) => {
    this.props.onSetReturnId(flightId, index);
    this.props.onCloseRoundTripFareRules();
    this.returnList.forceUpdateGrid();
  };

  clearBookingSummaryHandler = () => {
    this.props.onClearFlights();
    this.props.onToggleSidebar();
    this.departList.forceUpdateGrid();
    this.returnList.forceUpdateGrid();
  }

  flightTotalPrice = 0;

  componentWillUpdate() {
    this.departList.forceUpdateGrid();
    this.returnList.forceUpdateGrid();
  }

  renderRowOneWay = ({index, key, style}) => {
    return (
          <div style={style} key={key}>
            <TupleInner
                  flightSchedule={this.props.roundTripOnward[index].OD}
                  key={this.props.roundTripOnward[index].ID}
                  fareDetails={this.props.roundTripOnward[index].FD.O}
                  airlineNames={this.props.airlineNames}
                  flightId={this.props.roundTripOnward[index].ID}
                  searchId={this.props.searchId}
                  supplierCode={this.props.roundTripOnward[index].supplierCode}
                  index={index}
                  clicked={this.departHandler}
                  activeIndex={this.props.departIndex}
                  cityNames={this.props.cityNames}
                />
          </div>
    );
  }

  renderRowReturn = ({index, key, style}) => {
    return (
          <div style={style} key={key}>
            <TupleInner
                      flightSchedule={this.props.roundTripReturn[index].OD}
                      key={this.props.roundTripReturn[index].ID}
                      fareDetails={this.props.roundTripReturn[index].FD.O}
                      airlineNames={this.props.airlineNames}
                      flightId={this.props.roundTripReturn[index].ID}
                      searchId={this.props.searchId}
                      supplierCode={this.props.roundTripReturn[index].supplierCode}
                      index={index}
                      clicked={this.returnHandler}
                      activeIndex={this.props.returnIndex}
                      cityNames={this.props.cityNames}
                    />
          </div>
    );
  }

  proceedToBook = (e) => {
    e.stopPropagation();

    const fareDetailsO = this.props.departFlight[0].FD.O;
    const fareDetailsR = this.props.returnFlight[0].FD.O;

    this.props.onSetStackFlight(this.props.departFlight[0].OD, fareDetailsO, this.props.departDate, this.props.departFlight[0].supplierCode, this.props.departFlight[0].ID, "onward");
    this.props.onSetStackFlight(this.props.returnFlight[0].OD, fareDetailsR, this.props.arrivalDate, this.props.returnFlight[0].supplierCode, this.props.returnFlight[0].ID, "return");


    const flightTotalPriceO = Math.round(fareDetailsO.revisedFareDetails.af);
    const flightTotalPriceR = Math.round(fareDetailsR.revisedFareDetails.af);
    const flightTotalPrice = flightTotalPriceO + flightTotalPriceR;

    const searchId = this.props.searchId;
    const msId = this.props.searchId;

    const flightId = this.props.departFlight[0].ID + "," + this.props.returnFlight[0].ID;
    let supplierCode = "";
    if(this.props.departFlight[0].xmlKey === this.props.returnFlight[0].xmlKey) {
      supplierCode = this.props.departFlight[0].xmlKey;
    } else {
      supplierCode = this.props.departFlight[0].xmlKey + "," + this.props.returnFlight[0].xmlKey;
    }

    let flightCode = "";
    if(this.props.flightCodeRound !== "") {
      flightCode = this.props.flightCode + "," + this.props.flightCodeRound;
    } else {
      flightCode = this.props.flightCode;
    } 

    const queryParams = [];
    queryParams.push('searchId=' + searchId);
    queryParams.push('msid=' + msId);
    queryParams.push('mode=Instant');
    queryParams.push('bpc=true');
    queryParams.push('isSR=false');
    queryParams.push('flightIdCSV=' + flightId);
    queryParams.push('flightPrice=' + flightTotalPrice);
    queryParams.push('flightCode=' + flightCode);
    queryParams.push('sc=' + supplierCode);
    queryParams.push('isInt=' + false);
    const queryString = queryParams.join("&");
    this.props.history.push({
      pathname: '/reviews/details',
      search: "?" + queryString
    });
  }

  FirstChildHandler = (props) => {
    const childrenArray = React.Children.toArray(props.children);
    return childrenArray[0] || null;
  }

  render() {
    let departs = null;
    let returns = null;
    let bookingSummary = null;
    let totalFareO = 0;
    let totalFareR = 0;
    console.log(this.props.departFlight);
    console.log(this.props.returnFlight);
    const fareDetailsO = this.props.departFlight[0] ? this.props.departFlight[0].FD.O : null;
    const fareDetailsR = this.props.returnFlight[0] ? this.props.returnFlight[0].FD.O : null;

    if(fareDetailsO) {
      if(fareDetailsO.revisedFareDetails) {
        totalFareO = Math.round(parseFloat(fareDetailsO.revisedFareDetails.tf, 10)); 
      }
    }
    if(fareDetailsR) {
      if(fareDetailsR.revisedFareDetails) {
        totalFareR = Math.round(parseFloat(fareDetailsR.revisedFareDetails.tf, 10));
      }
    }

    const totalFare = totalFareO + totalFareR;
    // let selectedDepartFlight = null;
    // let selectedReturnFlight = null;
    // selectedDepartFlight = this.props.flights.dom.roundTripOnward.filter(flight => flight.ID === this.props.departId);
    // selectedReturnFlight = this.props.flights.dom.roundTripReturn.filter(flight => flight.ID === this.props.returnId);

    departs = <WindowScroller>
                {({height, isScrolling, onChildScroll, scrollTop}) => (
                    <AutoSizer disableHeight>
                        {({width}) => (
                            <List width={width}
                                  autoHeight
                                  height={height}
                                  isScrolling={isScrolling}
                                  onScroll={onChildScroll}
                                  rowRenderer={this.renderRowOneWay}
                                  rowCount={this.props.roundTripOnward.length}
                                  scrollTop={scrollTop}
                                  overscanRowCount={4}
                                  ref={c => this.departList = c}
                                  rowHeight={window.innerWidth > 600 ? 105 : 125  }/>
                        )}
                    </AutoSizer>   
                )}
            </WindowScroller>

     returns = <WindowScroller>
                  {({height, isScrolling, onChildScroll, scrollTop}) => (
                    <AutoSizer disableHeight>
                        {({width}) => (
                            <List 
                                  width={width}
                                  autoHeight
                                  height={height}
                                  isScrolling={isScrolling}
                                  onScroll={onChildScroll}
                                  rowRenderer={this.renderRowReturn}
                                  rowCount={this.props.roundTripReturn.length}
                                  scrollTop={scrollTop}
                                  overscanRowCount={2}
                                  ref={c => this.returnList = c}
                                  rowHeight={window.innerWidth > 600 ? 105 : 125}/>
                        )}
                    </AutoSizer>   
                )}
            </WindowScroller>

    bookingSummary = this.props.isDepartFlight || this.props.isReturnFlight ? ( 
      <FlightDetailsRoundTrip
          clicked={this.clearBookingSummaryHandler}
          proceedToBook={this.proceedToBook}
      /> ) : null;

    return (
      <React.Fragment>
        <Media query="(min-width: 1200px)">
          {matches =>
            matches ? (
              <ReactCSSTransitionGroup
                component={this.FirstChildHandler}
                transitionName="move-right"
                transitionEnterTimeout={1000}
                transitionLeaveTimeout={1000}
                transitionAppearTimeout={1000}>
                { bookingSummary }
              </ReactCSSTransitionGroup>
            ) : null}
        </Media>
        <div className={`u-flex justify-content-between`}>
          <div className={classes.DepartingContainer}>
            <RoundTripHeader
              type={window.innerWidth < 600 ? 'Departure' : 'Departure Flights'}
              origin={this.props.originCity}
              destination={this.props.destinationCity}
              date={this.props.departDate}
              prev={this.props.departPrev}
              next={this.props.departNext}
            />
              {departs}
          </div>
          <div className={classes.ReturningContainer}>
            <RoundTripHeader
              type={window.innerWidth < 600 ? 'Return' : 'Return Flights'} 
              origin={this.props.destinationCity}
              destination={this.props.originCity}
              date={this.props.arrivalDate}
              prev={this.props.returnPrev}
              next={this.props.returnNext}
            />
              {returns}
          </div>
          <Media query="(max-width: 599px)">
          {matches =>
            matches && this.props.mobileFlightDetail ? (
              <ReactCSSTransitionGroup
                component={this.FirstChildHandler}
                transitionName="move-right"
                transitionEnterTimeout={1000}
                transitionLeaveTimeout={1000}
                transitionAppearTimeout={1000}>
                { bookingSummary }
              </ReactCSSTransitionGroup>
            ) : null}
        </Media>
          {this.props.isDepartFlight || this.props.isReturnFlight ? (
            <div className={`${classes.ContainerFinal} u-flex justify-content-between align-items-center`}>
              <div>
                <HeadingH4 size={18} weight="Medium" color="White">You Pay &#8377; {parseInt(totalFare, 10).toLocaleString()}</HeadingH4>
                <p className={`u-cursorPointer u-fontSize13 u-textColorFluorescentGreen`} onClick={() => this.props.onToggleMobileFlightDetail()}>
                  <img src={flightDetailIcon} alt='Fare Breakup' className="u-size11x11 mr-1"/>
                  Flight Details
                </p>
              </div>
              <ButtonProceedMobile onClick={(e) => this.proceedToBook(e)} disabled={!this.props.isDepartFlight || !this.props.isReturnFlight}>CONTINUE</ButtonProceedMobile>
            </div>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    cityNames: state.flights.cityNames,
    airlineNames: state.flights.airlineNames,
    flightCode: state.flights.flightCode,
    flightCodeRound: state.flights.flightCodeRound,
    searchId: state.flights.searchId,
    roundTripFlights: state.flights.dom.roundTripFlights,
    roundTripOnward: state.flights.dom.roundTripFlights.roundTripOnward, 
    roundTripReturn: state.flights.dom.roundTripFlights.roundTripReturn,
    isDepartFlight: state.roundTripSummary.isDepartFlight,
    isReturnFlight: state.roundTripSummary.isReturnFlight,
    departFlight: state.flights.dom.roundTripFlights.roundTripOnward.filter(flight => flight.ID === state.roundTripSummary.departId),
    returnFlight: state.flights.dom.roundTripFlights.roundTripReturn.filter(flight => flight.ID === state.roundTripSummary.returnId),
    departIndex: state.roundTripSummary.departIndex,
    returnIndex: state.roundTripSummary.returnIndex,
    // departId: state.roundTripSummary.departId,
    // returnId: state.roundTripSummary.returnId,
    departDate: state.flights.departDate,
    arrivalDate: state.flights.arrivalDate,
    mobileFlightDetail: state.ui.mobileFlightDetail
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onToggleSidebar: () => dispatch(roundTripSummaryActions.toggleSidebar()),
    onSetDepartId: (id, index) => dispatch(roundTripSummaryActions.setDepartId(id, index)),
    onSetReturnId: (id, index) => dispatch(roundTripSummaryActions.setReturnId(id, index)),
    onClearFlights: () => dispatch(roundTripSummaryActions.clearFlights()),
    onSetStackFlight: (flightSchedule, fareDetails, date, supplierCode, flightId, flightType) => dispatch(stackFlightActions.setStackFlight(flightSchedule, fareDetails, date, supplierCode, flightId, flightType)),
    onToggleMobileFlightDetail: () => dispatch(uiActions.toggleMobileFlightDetail()),
    onCloseRoundTripFareRules: () => dispatch(uiActions.closeRoundTripFareRules())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(flightTupleRoundTrip));



// WEBPACK FOOTER //
// ./src/components/Flight/FlightTupleRoundTrip/FlightTupleRoundTrip.js